export default "/images/base_environment__icon.png";